import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { getCareerStagesHash } from './actions';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [getCareerStagesHash]: {
    next: (state: State.CareerStages, action: any): State.CareerStages => ({
      ...state,
      careerStagesHash: action.payload,
      careerStagesFetched: true,
    }),

    throw: (state: State.CareerStages, action: any): State.CareerStages => ({
      ...state,
      error: action.payload,
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
